export default "__VITE_ASSET__LbKRxokY__"